import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

/* Store links -- fill these in when each listing goes live. An empty string
   means "not published yet" and the UI falls back to a coming-soon note
   instead of rendering a dead link. */
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.nethajiprime.ott';
export const APP_STORE_URL  = 'https://apps.apple.com/in/app/nethaji-prime/id6798017679';
export const GET_APP_URL    = 'https://nethajiprime.com/get-app';

export function detectPlatform(uaRaw) {
  const ua = String(uaRaw || (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '').toLowerCase();
  if (ua.indexOf('android') !== -1) return 'android';
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  // iPadOS 13+ reports a desktop Safari UA; touch support disambiguates it.
  if (ua.indexOf('macintosh') !== -1 && typeof document !== 'undefined' && 'ontouchend' in document) return 'ios';
  return 'other';
}

/* Reusable QR + text options. Used on the login page and after a donation. */
export function GetAppQR({ size, showLinks, showCaption }) {
  const px = size || 132;
  return (
    <div className="np-getapp" style={{textAlign:'center'}}>
      <div className="np-getapp-qrbox" style={{display:'inline-block',background:'#fff',padding:'10px',borderRadius:'10px',lineHeight:0}}>
        <QRCodeSVG value={GET_APP_URL} size={px} level="M" title="Get the Nethaji Prime app" />
      </div>
      {showCaption !== false && (
        <div style={{color:'rgba(255,255,255,0.45)',fontSize:'11px',marginTop:'8px'}}>Scan to get the app</div>
      )}
      {showLinks !== false && (
        <div style={{marginTop:'8px',fontSize:'12px',lineHeight:1.7}}>
          {PLAY_STORE_URL
            ? <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" style={{color:'#00cc88',textDecoration:'none',display:'block'}}>Android (Google Play)</a>
            : <span style={{color:'rgba(255,255,255,0.45)',display:'block'}}>Android (Google Play) - coming soon</span>}
          {APP_STORE_URL
            ? <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" style={{color:'#00cc88',textDecoration:'none',display:'block'}}>iOS (App Store)</a>
            : <span style={{color:'rgba(255,255,255,0.45)',display:'block'}}>iOS - coming soon</span>}
        </div>
      )}
    </div>
  );
}

/* Standalone landing page. Android goes straight to Play when the listing is
   live; everything else gets the options plus the QR. */
export default function GetAppPage() {
  const [platform, setPlatform] = useState('other');
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const p = detectPlatform();
    setPlatform(p);
    if (p === 'android' && PLAY_STORE_URL) {
      setRedirecting(true);
      window.location.replace(PLAY_STORE_URL);
    }
  }, []);

  return (
    <div style={{minHeight:'100vh',background:'#040000',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'#0e0101',border:'1px solid rgba(212,168,67,0.15)',borderRadius:'14px',padding:'28px',maxWidth:'420px',width:'100%',textAlign:'center'}}>
        <div style={{fontSize:'40px',marginBottom:'8px'}}>&#128241;</div>
        <h1 style={{color:'#f5c842',fontFamily:"'Bebas Neue',sans-serif",fontSize:'26px',letterSpacing:'1px',margin:'0 0 6px'}}>
          Get the Nethaji Prime app
        </h1>
        <p style={{color:'#c8b89a',fontSize:'14px',lineHeight:1.6,margin:'0 0 18px'}}>
          Watch Tamil sociopolitical media on the go.
        </p>

        {platform === 'android' && (
          <p style={{color: redirecting ? '#00cc88' : '#c8b89a',fontSize:'13px',margin:'0 0 16px'}}>
            {redirecting ? 'Taking you to Google Play...' : 'Coming soon to Google Play.'}
          </p>
        )}
        {platform === 'ios' && (
          <p style={{color:'#c8b89a',fontSize:'13px',margin:'0 0 16px'}}>Coming soon to the App Store.</p>
        )}

        <GetAppQR size={150} />

        <div style={{marginTop:'20px'}}>
          <a href="/" style={{color:'rgba(255,255,255,0.4)',fontSize:'12px',textDecoration:'none'}}>Back to nethajiprime.com</a>
        </div>
      </div>
    </div>
  );
}
